import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import { createContext, useContext } from 'react';
import { CallPromptViewModel } from '../views/CallPrompt/CallPromptViewModel';
import memoize from 'memoizee';
export var CallingConversationViewModel = /*#__PURE__*/_createClass(function CallingConversationViewModel(_ref) {
  var _this = this;
  var rootStore = _ref.rootStore;
  _classCallCheck(this, CallingConversationViewModel);
  this.callPromptViewModelFor = memoize(function (call) {
    if (!call) {
      console.warn('callPromptViewModelFor requested for null call');
    }
    var vm = new CallPromptViewModel(call, _this.rootStore.callStore, _this.rootStore.getTime);
    vm.fetch();
    return vm;
  });
  this.rootStore = rootStore;
});
export var CallingConversationContext = /*#__PURE__*/createContext(null);
export function useCallingConversationViewModel() {
  return useContext(CallingConversationContext);
}
export var CallRootContext = /*#__PURE__*/createContext(null);
export function useCallRootViewModel() {
  return useContext(CallRootContext);
}
//# sourceMappingURL=index.js.map
